module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-regular.2c4bb91.woff2";